import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { HANDOVER_CHECKLIST, GATE_INFO,GATE_DETAIL } from './type';

export const getHandOver = (id, gateId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.handOver}?site_id=${id}&gate_id=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: HANDOVER_CHECKLIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const getGateInfo = (id, gateId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.gateInfo}?site_id=${id}&gate_id=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GATE_INFO,
      payload: data.response.data,
    });
    return true;
  }
};

export const getGateDetail = (id, gateId) => async (dispatch) => {
  dispatch({
    type: GATE_DETAIL,
    payload: {},
  });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.gateDetail}?site_id=${id}&gate_id=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GATE_DETAIL,
      payload: data.response.data,
    });
    return true;
  }
};

export const postHandOver = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveHandOver}`
  );
  if (res) {
    return true;
  }
};
